import { z } from 'zod';

export const currencyModelSchema = z.object({
  id: z.string(),
  type: z.literal('currency'),
  attributes: z.object({
    code: z.string(),
    symbol: z.string(),
    exchangeRate: z.number(),
  }),
});

export const loyaltyCurrencySchema = z.object({
  id: z.string(),
  name: z.string(),
  shortName: z.string(),
  denomination: z.number(),
  minimumTransfer: z.number(),
  maximumTransfer: z.number().nullable(),
  targetDenomination: z.number(),
  targetMinimumTransfer: z.number(),
  targetMaximumTransfer: z.number().nullable(),
  exchangeRate: z.number(),
});

export const loyaltyCurrencyModelSchema = z.object({
  id: z.string(),
  type: z.literal('loyalty_currency'),
  attributes: loyaltyCurrencySchema.omit({ id: true }),
});
